import { createPlugin, createApiFactory, configApiRef, fetchApiRef, createRoutableExtension } from '@backstage/core-plugin-api';
import { kongServiceManagerApiRef } from './api/KongServiceManagerApi.esm.js';
import { KongServiceManagerApiClient } from './api/KongServiceManagerClient.esm.js';
import { kongServiceRouteRef, routesListRouteRef, pluginsListRouteRef, removePluginRouteRef, addPluginRouteRef, sepcsListRouteRef } from './routes.esm.js';
import { scmAuthApiRef, scmIntegrationsApiRef } from '@backstage/integration-react';

const kongServiceManagerPlugin = createPlugin({
  id: "kong-service-manager",
  routes: {
    root: kongServiceRouteRef,
    routesList: routesListRouteRef,
    pluginsList: pluginsListRouteRef,
    removePlugin: removePluginRouteRef,
    addPlugin: addPluginRouteRef,
    allSpecs: sepcsListRouteRef
  },
  apis: [
    createApiFactory({
      api: kongServiceManagerApiRef,
      deps: { config: configApiRef, fetchApi: fetchApiRef, scmAuthApi: scmAuthApiRef, scmIntegrationsApi: scmIntegrationsApiRef },
      factory: ({ config, fetchApi, scmAuthApi, scmIntegrationsApi }) => {
        return new KongServiceManagerApiClient({
          config,
          fetchApi,
          scmAuthApi,
          scmIntegrationsApi
        });
      }
    })
  ]
});
const KongServiceManagerContent = kongServiceManagerPlugin.provide(
  createRoutableExtension({
    name: "KongServiceManagerContent",
    component: () => import('./components/KongServiceManagerHomepage/index.esm.js').then((m) => m.KongServiceManagerHomepage),
    mountPoint: kongServiceRouteRef
  })
);

export { KongServiceManagerContent, kongServiceManagerPlugin };
//# sourceMappingURL=plugin.esm.js.map
